import axiosIns from "@/api/axios";
import querystring from "query-string";

export const GET_DATA_LIST = (params) => {
    return axiosIns.get(`/capex-gl?${params}`);
};

export const CREATE_DATA = (body) => {
    return axiosIns.post('/capex-gl', body);
};

export const DELETE_DATA = (id) => {
    return axiosIns.delete(`/capex-gl/${id}`);
};

export const UPDATE_DATA = (body) => {
    return axiosIns.put(`/capex-gl/${body.id}`, body.body);
};
export const GET_DATA_LIST_BOX = (id, fund_center_id) => {
    return axiosIns.get(`/account/listbox-capex-relocate/${id}/${fund_center_id}`);
};
